<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Approve Funding Revision</p>
      </header>
      <section class="modal-card-body">
        <div class="pa-xl has-text-centered">
          <p class="mb-sm">
            When you approve a funding revision, the funding line items will be updated with revised values.
            Are you sure?
          </p>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Approve Funding Revision</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters(['api', 'context'])
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/admin/revisions/' + this.revision.id + '/actions/approve'
      this.$http.put(endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Funding approved!' })
        this.$emit('revision:saved', response.data)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      saving: false,
      errors: []
    }
  },
  props: {
    revision: {
      type: Object,
      required: true
    }
  }
}
</script>
